import { Reducer } from 'redux';
import { CampaignsAction } from './actions';
import { CampaignsState } from './types';
import { camelCaseValues } from './utils';

const initialState: CampaignsState = {};

const reducer: Reducer<CampaignsState, CampaignsAction> =
  function campaignsReducer(state = initialState, action) {
    switch (action.type) {
      case 'GET_CAMPAIGNS_CONFIG':
        return {
          ...state,
          config: {},
        };

      case 'GET_CAMPAIGNS_CONFIG_SUCCESS':
        return {
          ...state,
          config: action.payload,
        };

      case 'GET_CAMPAIGNS_SCHEDULE':
        return {
          ...state,
          schedule: {},
        };

      case 'GET_CAMPAIGNS_SCHEDULE_SUCCESS':
        return {
          ...state,
          schedules: camelCaseValues(action.payload),
        };

      case 'GET_TOTAL_PERFORMANCE_METRICS_SUCCESS':
        return {
          ...state,
          performanceMetrics: {
            ...state.performanceMetrics,
            total: {
              ...state.performanceMetrics?.total,
              [action.extra.id]: action.payload.performanceMetrics,
            },
          },
        };

      case 'GET_WEEKLY_PERFORMANCE_METRICS_SUCCESS':
        return {
          ...state,
          performanceMetrics: {
            ...state.performanceMetrics,
            weekly: action.payload.performanceMetrics.reverse(),
          },
        };

      case 'SET_CAMPAIGN_START':
        return {
          ...state,
          inCreation: {
            ...state.inCreation,
            startAt: action.startAt,
          },
        };

      case 'SET_CAMPAIGN_END':
        return {
          ...state,
          inCreation: {
            ...state.inCreation,
            endAt: action.endAt,
          },
        };

      case 'SET_CAMPAIGN_RESTAURANTS':
        return {
          ...state,
          inCreation: {
            ...state.inCreation,
            restaurantIds: action.restaurantIds,
          },
        };

      case 'SET_CAMPAIGN_BID':
        return {
          ...state,
          inCreation: {
            ...state.inCreation,
            bid: action.bid,
          },
        };

      case 'SET_CAMPAIGN_BUDGET':
        return {
          ...state,
          inCreation: {
            ...state.inCreation,
            budget: action.budget,
          },
        };

      case 'SET_CAMPAIGN_TARGET':
        return {
          ...state,
          inCreation: {
            ...state.inCreation,
            targeting: action.targeting,
          },
        };
      case 'SET_CAMPAIGN_TYPE':
        return {
          ...state,
          inCreation: {
            ...state.inCreation,
            budgetType: action.budgetType,
          },
        };
      case 'SET_CAMPAIGN_BID_TYPE':
        return {
          ...state,
          inCreation: {
            ...state.inCreation,
            bidType: action.bidType,
          },
        };
      case 'SET_CAMPAIGN_VALIDATION':
        return {
          ...state,
          inCreation: {
            ...state.inCreation,
            isValidating: action.validate,
          },
        };

      default:
        return state;
    }
  };

export default reducer;
